<template>
  <div class="create-isr">
    <Modal
      size="medium"
      primary-button-label="Save"
      tertiary-button-label="Cancel"
      close-on-click-outside
      active
      class="create-isr__modal"
      @onClose="onClose()"
      @onConfirm="onSubmitClick()">
      <div slot="header">Create new ISR</div>
      <div slot="content" class="create-isr__modal__content">
        <notification
          v-if="errorMessage"
          icon="info-circle"
          type="error"
          title="Review the errors on this page"
          classes="custom-toast">
          <div v-for="err in errorMessage" :key="err">
            <div v-html="err"></div>
          </div>
        </notification>
        <notification
          icon="info-circle"
          type="info"
          classes="custom-toast"
          class="create-isr__modal__content__info">
          <div>
            Requestor dept field depends on CM Visibility. Please check your
            profile and choose accordingly.
          </div>
        </notification>
        <Form
          ref="createIsrForm"
          :form-data="formData"
          :default-values="fieldValues"
          @onSubmitForm="onSubmit"
          @updateOnSearch="updateOnSearch"
          @onChange="updateOnChange"></Form>
      </div>
    </Modal>
  </div>
</template>

<script>
// constants
import { createIsrFormData } from "@/config/isrConstant.js";

export default {
  name: "CreateISR",
  props: {
    caseDetailsSfdc: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: createIsrFormData() || [],
      fieldValues: {},
      errorMessage: null,
    };
  },
  created() {
    const formFields = this.formData.map((form) => form.formFields);
    [].concat.apply([], formFields).forEach((el) => {
      this.fieldValues[el.name] = null;
    });
    this.fieldValues.account_name = this.caseDetailsSfdc?.account_name;
    this.fieldValues.status = "New";
    this.fieldValues.liner_brand = this.caseDetailsSfdc?.liner_brand;
    this.fieldValues.subject = this.caseDetailsSfdc?.subject;
    this.fieldValues.description = this.caseDetailsSfdc?.description;
    this.fieldValues.mll = this.caseDetailsSfdc?.mll;
    this.fieldValues.contact_name = this.caseDetailsSfdc?.contact_name;
  },
  methods: {
    onClose() {
      this.$emit("onModalClose");
    },
    onSubmitClick() {
      this.$refs.createIsrForm.validate();
    },
    onSubmit(formState) {
      const {
        idTokenClaims: { EmployeeID: employeeId },
      } = this.$store.getters.getTokenData;
      const data = {
        ...formState,
        country: formState?.country?.id,
        created_by: employeeId,
        parent_id: this.caseDetailsSfdc?.id,
        supplied_email: this.caseDetailsSfdc?.contact_email,
      };
      this.$emit(
        "createIsr",
        data,
        () => {
          this.$emit("onModalClose");
          this.$emit("refreshIsrData");
        },
        (err) => {
          this.getErrorMessages(err);
          document.getElementsByClassName("modal__content")[0].scrollTop = 0;
        }
      );
    },
    updateOnChange(currentDiff) {
      if (
        Object.prototype.hasOwnProperty.call(currentDiff || {}, "resolver_dept")
      ) {
        this.$refs.createIsrForm?.updateFormState("collaboration_reason", "");
        this.$refs.createIsrForm?.updateFormState(
          "collaboration_reason_other",
          ""
        );
      }
    },
    updateOnSearch(searchTerm) {
      this.$emit(
        "getCountryList",
        `countryName=${searchTerm.searchValue}`,
        (countryList) => {
          let uniqueCountryList = Array.from(
            new Set(countryList.map((item) => item.countryGeoId))
          ).map((countryGeoId) => {
            const countryData = countryList.find(
              (item) => item.countryGeoId === countryGeoId
            );
            return {
              id: countryGeoId,
              name: countryData.countryName,
              label: countryData.countryName,
              value: countryData.countryName,
            };
          });
          this.formData = createIsrFormData(uniqueCountryList);
        }
      );
    },
    getErrorMessages(err) {
      const errorMessagesList = [];
      err.forEach((error) => {
        const errObj = JSON.parse(error);
        errObj.forEach((item) => {
          if (item && "message" in item && item.message) {
            errorMessagesList.push(item.message);
          }
        });
      });
      this.errorMessage = errorMessagesList;
    },
  },
};
</script>

<style lang="scss">
.create-isr {
  .modal--medium {
    height: 92vh;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  .modal__content--info {
    margin-top: 10px;
  }
  .form-input__field:disabled {
    color: var(--Gray-900);
  }
}
</style>
